export default {
  default: () => import("/home/ec2-user/biz_partners_frontend/src/layouts/default.vue").then(m => m.default || m)
}